import React from 'react';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from 'styled-components';

import GlobalStyle from './styles/GlobalStyle';
import themes from './styles/themes';

import history from './services/history';

import Routes from './routes/index';

import AppProvider from './hooks';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={themes}>
      <Router history={history}>
        <AppProvider>
          <Routes />
        </AppProvider>

        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          pauseOnHover
        />
        <GlobalStyle />
      </Router>
    </ThemeProvider>
  );
};

export default App;
